import type { ElementType, HTMLAttributes, ReactNode } from "react";
import styles from "./Container.module.css";

type Width = "narrow" | "default" | "wide";

type ContainerProps = HTMLAttributes<HTMLElement> & {
  as?: ElementType;
  width?: Width;
  children: ReactNode;
};

export default function Container({
  as: Tag = "div",
  width = "default",
  className,
  children,
  ...rest
}: ContainerProps) {
  const widthClass =
    width === "narrow"
      ? styles.narrow
      : width === "wide"
        ? styles.wide
        : styles.default;

  return (
    <Tag className={[styles.container, widthClass, className].filter(Boolean).join(" ")} {...rest}>
      {children}
    </Tag>
  );
}
